export const allowedUploadFileExtensions = [
    'jpg',
    'jpeg',
    'png',
    'docx',
    'pptx',
    'xlsx',
    'pdf',
];
